module.exports = __webpack_public_path__ + "img/30d66a4bc5b4e15d29a4b09845f047fc.png";